export const RecoveringActionTypes = {
  SetRecoveredTranscriptionFile: "RECOVERING_SET_RECOVERED_TRANSCRIPTION_FILE",
  SetRecoveryFlowCancelDialog: "RECOVERING_SET_RECOVERY_FLOW_CANCEL_DIALOG",
  SetAudioFile: "RECOVERING_SET_AUDIO_FILE",
  SetRecoveredTranscriptionFileInRecoveryFlow: "RECOVERING_SET_RECOVERED_TRANSCRIPTION_FILE_IN_RECOVERY_FLOW"
};